import { render, staticRenderFns } from "./PostingPageData.vue?vue&type=template&id=9fc83354&scoped=true"
import script from "./PostingPageData.vue?vue&type=script&lang=js"
export * from "./PostingPageData.vue?vue&type=script&lang=js"
import style0 from "./PostingPageData.vue?vue&type=style&index=0&id=9fc83354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc83354",
  null
  
)

export default component.exports